import { v4 as uuidv4 } from 'uuid';
import { ESProductColor, ESProductMedia, ProductColor } from '../../../products/ProductTypes';
import { ListProductColorDTO } from '../../../products/colors/product-color.types';
import { OfflineDatabaseProductColor } from '../../database/offlineDatabase/types/offlineDatabaseProductColor.types';

export class OfflineProductColorTransformers {
  static toProductColor(offlineProductColor: OfflineDatabaseProductColor): ProductColor {
    return {
      active: true,
      unique: false,
      customized: false,
      referenceColors: [],
      classifications: [],
      id: offlineProductColor.id,
      code: offlineProductColor.code,
      name: offlineProductColor.name,
      hexcode: offlineProductColor.hexcode,
      isImage: offlineProductColor.isImage,
      colorId: offlineProductColor.colorId,
      imageUrl: offlineProductColor.imageUrl,
      allowChangeImmediateGrid: offlineProductColor.allowChangeImmediateGrid,
      allowChangePreOrderGrid: offlineProductColor.allowChangePreOrderGrid,
    };
  }

  static toListProductColorDTO(
    offlineProductColor: OfflineDatabaseProductColor,
  ): ListProductColorDTO {
    return {
      active: true,
      customized: false,
      referenceColors: [],
      unique: false,
      id: offlineProductColor.id,
      name: offlineProductColor.name,
      code: offlineProductColor.code,
      colorId: offlineProductColor.id,
      hexcode: offlineProductColor.hexcode,
      isImage: offlineProductColor.isImage,
      allowChangePreOrderGrid: offlineProductColor.allowChangePreOrderGrid,
      allowChangeImmediateGrid: offlineProductColor.allowChangeImmediateGrid,
    };
  }

  static toESProductColor(offlineProductColor: OfflineDatabaseProductColor): ESProductColor {
    return {
      id: offlineProductColor.colorId,
      referenceColor: [],
      code: offlineProductColor.code,
      name: offlineProductColor.name,
      isImage: offlineProductColor.isImage,
      imageUrl: offlineProductColor.imageUrl,
      hexcode: offlineProductColor.hexcode,
      productColorId: offlineProductColor.id,
      allowChangePreOrderGrid: offlineProductColor.allowChangePreOrderGrid,
      allowChangeImmediateGrid: offlineProductColor.allowChangeImmediateGrid,
    };
  }

  static toESProductMedia(offlineProductColor: OfflineDatabaseProductColor): ESProductMedia {
    return {
      id: uuidv4(),
      type: 'IMAGE',
      position: 0,
      processed: true,
      url: offlineProductColor.medias?.[0]?.url || '', // TODO: NÃO NECESSARIAMENTE VÁ EXISTIR UMA FOTO, PODE SER BOM TERMOS UMA DE FALLBACK,
    };
  }

  static toESProductMedias(offlineProductColor: OfflineDatabaseProductColor): ESProductMedia[] {
    return offlineProductColor.medias.map((productColorMedia, index) => ({
      id: uuidv4(),
      type: 'IMAGE',
      position: index,
      processed: true,
      url: productColorMedia.url || '',
    }));
  }
}
